export default "__VITE_PUBLIC_ASSET__c9f99f09__"